'use strict';

angular.module('helpers.array', [])

.factory('arrayHelpers', [function () {
    var helpers = {};

    helpers.getGroupsOfArrays = function (array, nbElementsByGroup) {
        var groups = [];

        var idxElt = 0;
        var group = [];

        _.forEach(array, function (element) {
            if ((idxElt % nbElementsByGroup) == 0) {
                group = [];
                groups.push(group);
            }

            group.push(element);

            idxElt += 1;
        });

        return groups;
    };

    return helpers;
}]);

